var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-grid',{ref:"grid",attrs:{"dataSource":_vm.data,"columns":_vm.tableColumns,"allowResizing":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }